const Illustration = (props) => (
  <svg
    width={1090}
    height={900}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 842 695"
    {...props}
  >
    <ellipse cx={641} cy={393.5} rx={155} ry={152.5} fill="#E96D6D" />
    <path fill="#D6FEAE" d="M164.7 104.256h321.714v295.132H164.7z" />
    <path
      d="M486.369 399.108c0-38.721-8.372-77.062-24.639-112.835-16.266-35.773-40.109-68.278-70.166-95.657-30.057-27.38-65.739-49.098-105.011-63.916-39.271-14.818-81.362-22.444-123.868-22.444v294.852h323.684Z"
      fill="#000"
    />
    <path
      d="M324.353 399.746c0-19.391-4.193-38.593-12.34-56.509-8.147-17.915-20.087-34.194-35.14-47.906-15.053-13.712-32.923-24.589-52.591-32.01-19.667-7.421-40.747-11.24-62.035-11.24v147.665h162.106Z"
      fill="#F1C8DB"
    />
    <path fill="#D6FEAE" d="M327 399h321.714v295.132H327z" />
    <path
      d="M325.361 398.665c0 38.721 8.372 77.062 24.639 112.835 16.267 35.773 40.109 68.277 70.166 95.657 30.057 27.379 65.74 49.098 105.011 63.916 39.271 14.817 81.362 22.444 123.869 22.444V398.665H325.361Z"
      fill="#5171A5"
    />
    <path
      d="M487 398.666c0 19.391 4.193 38.593 12.34 56.509 8.146 17.915 20.087 34.194 35.14 47.906 15.053 13.712 32.923 24.589 52.59 32.01 19.668 7.421 40.748 11.24 62.035 11.24V398.666H487ZM864.499 0l2.641 141.53L902.027 3.593 872.308 142.53l65.607-128.315-60.781 130.273 93.461-113.086-89.187 115.914 117.229-92.913-113.694 96.49 135.877-68.681-133.236 72.848 148.586-41.446-146.953 46.023 154.793-12.401-154.241 17.187 154.241 17.187-154.793-12.401 146.953 46.024-148.586-41.447 133.236 72.849-135.877-68.682 113.694 96.49-117.229-92.913 89.187 115.914-93.461-113.086 60.781 130.273-65.607-128.315 29.719 138.937-34.887-137.937-2.641 141.53-2.642-141.53-34.887 137.937 29.72-138.937-65.608 128.315 60.782-130.273-93.461 113.086L847.59 181.53l-117.23 92.913 113.695-96.49-135.875 68.682 133.233-72.849-148.581 41.447 146.949-46.024-154.795 12.401 154.242-17.187-154.242-17.187 154.795 12.401-146.949-46.023 148.581 41.446L708.18 82.211l135.875 68.682-113.695-96.49 117.23 92.913-89.187-115.914 93.461 113.086-60.782-130.273L856.69 142.53 826.97 3.593l34.887 137.937L864.499 0Z"
      fill="#000"
    />
  </svg>
);

export default Illustration;
